import { api } from "@/lib/api";

export const engageApi = {
    campaigns: {
        list: () => api.get("/campaigns").then((r) => r.data),
        get: (id) => api.get(`/campaigns/${id}`).then((r) => r.data),
        create: (body) => api.post("/campaigns", body).then((r) => r.data),
        update: (id, body) => api.patch(`/campaigns/${id}`, body).then((r) => r.data),
        remove: (id) => api.delete(`/campaigns/${id}`).then((r) => r.data),
        send: (id) => api.post(`/campaigns/${id}/send`).then((r) => r.data),
        events: (id, limit = 100) => api.get(`/campaigns/${id}/events`, { params: { limit } }).then((r) => r.data),
    },
    templates: {
        list: () => api.get("/templates").then((r) => r.data),
        create: (body) => api.post("/templates", body).then((r) => r.data),
        remove: (id) => api.delete(`/templates/${id}`).then((r) => r.data),
    },
    emails: {
        generate: (lead_id, sender_name, value_prop) =>
            api.post("/emails/generate", { lead_id, sender_name, value_prop }).then((r) => r.data),
    },
    inbox: (type = "reply", limit = 50) =>
        api.get("/inbox", { params: { type, limit } }).then((r) => r.data),
};
